/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid202,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid400,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid401,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid500,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonidMutationResponse,
  PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonidPathParams,
} from "../../types/courseRegistrationEnrollmentController/PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid.ts";

export const putApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonidPathParamsSchema =
  z.object({
    courseRegistrationId: z.coerce.number().int(),
    indicatorPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonidPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid202Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid400Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid401Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid500Schema =
  z.any() as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid500>;

export const putApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonidMutationResponseSchema =
  z.lazy(
    () =>
      putApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonid202Schema,
  ) as unknown as ToZod<PutApiV1CourseregistrationEnrollmentCourseregistrationidStudentIndicatorIndicatorpersonidMutationResponse>;
